var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 4.66602H7.33301M9.33301 11.3327H3.33301",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 13.332C12.4376 13.332 13.333 12.4366 13.333 11.332C13.333 10.2275 12.4376 9.33203 11.333 9.33203C10.2284 9.33203 9.33301 10.2275 9.33301 11.332C9.33301 12.4366 10.2284 13.332 11.333 13.332Z",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 6.66602C5.77059 6.66602 6.66602 5.77059 6.66602 4.66602C6.66602 3.56145 5.77059 2.66602 4.66602 2.66602C3.56145 2.66602 2.66602 3.56145 2.66602 4.66602C2.66602 5.77059 3.56145 6.66602 4.66602 6.66602Z",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTypeIcon);
export default __webpack_public_path__ + "static/media/edit-type-icon.10a3637e5687435f28e6e686dbd7e966.svg";
export { ForwardRef as ReactComponent };